/** Ajax table */
import React from 'react';
import {Table} from 'antd';

class ComTable extends React.Component{
  state = {
    scrollY: 560
  };
  // 页面跳转
  toPage(row) {
    const {dateTimeVal, startTime, endTime} = this.props.dateTime;
    const params = {
      url: row.resourcePath,
      dateTimeVal,
      startTime,
      endTime,
      methodType: row.methodType
    };
    sessionStorage.setItem('ajaxDetail', JSON.stringify(params));
    this.props.history.push(`/apm/ajaxPage/ajaxDetail?url=${row.resourcePath}`);
  };
  columns = [
    {
      title: 'URL',
      dataIndex: 'resourcePath',
      render: (val, row, index) => (
        <span className="c-primary cursor" onClick={() => this.toPage(row)}>{row.resourcePath}</span>
      ),
    }, {
      title: '调用次数',
      dataIndex: 'requestTimes',
      width: 120,
      sorter: true,
      showSorterTooltip: false
    }, {
      title: '请求方式',
      dataIndex: 'methodType',
      width: 120,
      sorter: true,
      showSorterTooltip: false
    }, {
      title: '平均响应耗时',
      dataIndex: 'avgRequestTime',
      sorter: true,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{row.avgRequestTime} ms</span>
      )
    }, {
      title: '平均返回数据大小',
      dataIndex: 'avgDecodedBodySize',
      sorter: true,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{(+row.avgDecodedBodySize / 1024).toFixed(3)} kb</span>
      )
    }, {
      title: '正确率',
      dataIndex: 'rightRate',
      width: 110,
      sorter: true,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{row.rightRate}%</span>
      )
    }, {
      title: '异常次数',
      dataIndex: 'errorCount',
      width: 120,
      sorter: true,
      showSorterTooltip: false
    },
  ];
  UNSAFE_componentWillMount() {
    this.setState({
      scrollY: document.documentElement.clientHeight - 300
    });
    window.onresize= () => {
      this.setState({
        scrollY: document.documentElement.clientHeight - 300
      })
    }
  };
  render() {
    const { tbData, pagination, loading } = this.props;
    const { scrollY } = this.state;
    return (
      <Table scroll={{x: 1000, y: scrollY}} rowKey={(record, index) => index} bordered loading={loading} pagination={pagination}
        columns={this.columns} dataSource={tbData} onChange={this.props.pageChange} />
    );
  }
};
export default ComTable;
